import { combineReducers } from 'redux'
import storage from 'redux-persist/lib/storage'

import authReducer from './slices/auth'

import layout from './layout'
import navbar from './navbar'

const rootPersistConfig = {
	key: 'root',
	version: 1,
	storage
}

const rootReducer = combineReducers({
	auth: authReducer,
	layout,
	navbar
})

export { rootPersistConfig, rootReducer }
